// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//
export enum AssetType {
  building = 1,
  mapping = 2,
  tower = 3
}

export const ASSET_TYPE_LABELS = {
  [AssetType.building]: 'Building',
  [AssetType.mapping]: 'Maping',
  [AssetType.tower]: 'Tower',
};

// Note: next two must match portal-api::TowerType
export enum AssetConstructionType {
  unknown = 0,
  monopole = 1,
  lattice = 2,
  guyed = 3,
  rooftop = 4,
  stealthStructure = 5,
  COW = 6,
  buildingSideMount = 7,
  waterTank = 8,
  SelfSupportTower = 9,
  MultiMastStructure = 10,
  // StreetWorksPole = 11,
  RduStructure = 11,
  ruralDeploymentStructure = 12,
  rooftopGuyedPole = 13,
  rooftopCornerTripods = 14,
  rooftopPolesWallMount = 15,
  _3lSst = 16,
  _4lSst = 17
}

export const ASSET_CONSTRUCTION_TYPE_LABELS = {
  [AssetConstructionType.unknown]: 'Unknown',
  [AssetConstructionType.monopole]: 'Monopole',
  [AssetConstructionType.lattice]: 'Self-Supporting Lattice',
  [AssetConstructionType.guyed]: 'Guyed',
  [AssetConstructionType.rooftop]: 'Rooftop',
  [AssetConstructionType.stealthStructure]: 'Stealth structure',
  [AssetConstructionType.COW]: 'COW',
  [AssetConstructionType.buildingSideMount]: 'Building-Side Mount',
  [AssetConstructionType.waterTank]: 'Watertank',
  [AssetConstructionType.SelfSupportTower]: 'Self-Support Tower',
  [AssetConstructionType.MultiMastStructure]: 'Multi-mast structure',
  [AssetConstructionType.RduStructure]: 'RDU structure',
  [AssetConstructionType.ruralDeploymentStructure]: 'Rural deployment structure',
  [AssetConstructionType.rooftopGuyedPole]: 'Rooftop guyed pole',
  [AssetConstructionType.rooftopCornerTripods]: 'Rooftop corner tripods',
  [AssetConstructionType.rooftopPolesWallMount]: 'Rooftop poles / Wall mounts',
  [AssetConstructionType._3lSst]: '3L SST',
  [AssetConstructionType._4lSst]: '4L SST',
  // [AssetConstructionType.StreetWorksPole]: 'Street works pole',
};

export const TOWER_FIELDS = {
  id: 'id',
  name: 'name',
  customerId: 'customerId',
  customerName: 'customerName',
  type: 'type',
  lastUpdated: 'lastUpdated',
  serialNumber: 'serialNumber',
  assetImageUrl: 'assetImageUrl',
  imageInfo: {
    name: 'imageInfo',
    fields: {
      image: 'image',
      imageSet: 'imageSet',
    }
  },
  address: {
    name: 'address',
    fields: {
      state: 'state',
      city: 'city',
      zipCode: 'zipCode',
      country: 'country',
      addressLine: 'addressLine',
    }
  },
  coordinates: {
    name: 'coordinates',
    fields: {
      lat: 'lat',
      lon: 'lon',
    }
  },
  construction: {
    name: 'construction',
    fields: {
      type: 'type',
      height: 'height',
    }
  },
  note: 'note',
  createdBy: 'createdBy',
  createdById: 'createdById',
  isBlocked: 'isBlocked',
  isActive: 'isActive'
};